module.exports = __webpack_public_path__ + "img/gps.71f27910.svg";